module.exports = __webpack_public_path__ + "static/img/solution-h5.ea6abf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-h5.png
// module id = DRkN
// module chunks = 34